import { DISPLAY_STATUS, mapToDisplayStatus, isWithinEditWindow } from '@claim-os/shared';

/**
 * Portal-only: a Pending-collapsing status (Pending, New, Pending Information) shows as
 * Processing once the edit window has closed; the raw status is returned otherwise.
 * An unknown window (null/undefined `editableUntil`) never shows a false Processing;
 * pass `windowClosed` when the row can only exist after the window closed.
 */
export function portalDisplayStatus(
  status: string,
  editableUntil: string | null | undefined,
  windowClosed = false,
): string {
  if (mapToDisplayStatus(status) !== DISPLAY_STATUS.PENDING) {
    return status;
  }
  if (windowClosed) {
    return DISPLAY_STATUS.PROCESSING;
  }
  if (editableUntil == null) {
    return status;
  }
  return isWithinEditWindow(editableUntil) ? status : DISPLAY_STATUS.PROCESSING;
}
